export const zIndex = {
    lowest: 10,
    low: 20,
    medium: 30,
    high: 40,
    highest: 50,
    priority: 100,
}
